/**
 * School Junkie Wishlist Functionality
 * Cookie-based wishlist management
 */

class SchoolJunkieWishlist {
  constructor() {
    this.cookieName = 'ttwishlistList';
    this.init();
  }

  init() {
    this.updateWishlistButtons();
    this.initWishlistButtons();
    // Clean up any existing count badges
    this.updateWishlistCount(0);
  }

  // Initialize wishlist button click handlers
  initWishlistButtons() {
    const addButtons = document.querySelectorAll('.add-in-wishlist-js');

    addButtons.forEach(button => {
      // Remove any existing event listeners
      button.removeEventListener('click', this.handleWishlistClick);

      // Add new event listener with high priority
      button.addEventListener('click', (event) => {
        console.log('Wishlist button clicked!', event.target);
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const productHandle = button.getAttribute('href');

        // Try multiple ways to get product title
        let productTitle = productHandle;
        const cardWrapper = button.closest('.card-wrapper, .card, .product-card');
        if (cardWrapper) {
          const titleElement = cardWrapper.querySelector('.card__heading a, .card-title, .product__title, h3 a, .wishlist-product-title');
          if (titleElement) {
            productTitle = titleElement.textContent?.trim() || productHandle;
          }
        }

        console.log('Adding to wishlist:', productHandle, productTitle);
        this.addToWishlist(productHandle, productTitle);

        return false;
      }, true); // Use capture phase
    });

    // Handle remove from wishlist buttons
    const removeButtons = document.querySelectorAll('.product-remove-js');
    removeButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const row = button.closest('tr');
        const productHandle = row?.className;

        this.removeFromWishlist(productHandle, row);
      });
    });
  }

  // Add product to wishlist
  addToWishlist(productHandle, productTitle) {
    if (!productHandle) return;

    let wishlistStr = this.getCookie(this.cookieName) || '';

    // Check if product is already in wishlist
    if (wishlistStr.indexOf(productHandle) !== -1) {
      this.showMessage(`${productTitle} is already in your wishlist!`, 'info');
      return;
    }

    // Add to wishlist
    if (wishlistStr === '') {
      wishlistStr = productHandle;
    } else {
      wishlistStr += '__' + productHandle;
    }

    this.setCookie(this.cookieName, wishlistStr, 14);
    this.updateWishlistButtons();
    this.showMessage(`${productTitle} added to wishlist!`, 'success');
  }

  // Remove product from wishlist
  removeFromWishlist(productHandle, row) {
    if (!productHandle) return;

    let wishlistStr = this.getCookie(this.cookieName) || '';
    wishlistStr = wishlistStr.replace(productHandle, '');
    wishlistStr = wishlistStr.replace('____', '__');
    wishlistStr = wishlistStr.replace(/^__/, '').replace(/__$/, '');

    this.setCookie(this.cookieName, wishlistStr, 14);

    if (row) {
      row.style.transition = 'opacity 0.5s';
      row.style.opacity = '0';
      setTimeout(() => {
        row.remove();
        this.checkEmptyWishlist();
      }, 500);
    }

    this.updateWishlistButtons();
    this.showMessage('Product removed from wishlist', 'success');
  }

  // Update wishlist button states
  updateWishlistButtons() {
    const wishlistStr = this.getCookie(this.cookieName) || '';
    const wishlistItems = wishlistStr ? wishlistStr.split('__') : [];

    console.log('Updating wishlist buttons. Current wishlist:', wishlistItems);

    document.querySelectorAll('.add-in-wishlist-js').forEach(button => {
      const productHandle = button.getAttribute('href');
      const container = button.closest('.add-to-wishlist');

      console.log('Checking button for product:', productHandle, 'In wishlist:', wishlistItems.includes(productHandle));

      if (!container) {
        console.log('No container found for button:', productHandle);
        return;
      }

      const defaultBtn = container.querySelector(`.default-wishbutton-${productHandle}`);
      const addedBtn = container.querySelector(`.added-wishbutton-${productHandle}`);

      console.log('Found elements:', { defaultBtn: !!defaultBtn, addedBtn: !!addedBtn });

      if (wishlistItems.includes(productHandle)) {
        if (defaultBtn) defaultBtn.style.display = 'none';
        if (addedBtn) addedBtn.style.display = 'block';
        console.log('Showing added state for:', productHandle);
      } else {
        if (defaultBtn) defaultBtn.style.display = 'block';
        if (addedBtn) addedBtn.style.display = 'none';
        console.log('Showing default state for:', productHandle);
      }
    });

    // Update header wishlist icon count - disabled
    // this.updateWishlistCount(wishlistItems.length);
  }

  // Update wishlist count in header - DISABLED
  updateWishlistCount(count) {
    // Remove any existing count badges
    const wishlistIcon = document.querySelector('.header__icon--wishlist');
    if (!wishlistIcon) return;

    const countBadge = wishlistIcon.querySelector('.wishlist-count');
    if (countBadge) {
      countBadge.remove();
    }
  }

  // Check if wishlist is empty on wishlist page
  checkEmptyWishlist() {
    const wishlistTable = document.querySelector('.wishlist_table tbody');
    if (wishlistTable && !wishlistTable.querySelector('tr:not(.wishlist-empty)')) {
      wishlistTable.innerHTML = '<tr class="wishlist-empty"><td colspan="6" style="text-align:center;padding:2rem;">Your wishlist is empty</td></tr>';
    }
  }

  // Show notification message
  showMessage(message, type = 'info') {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `wishlist-notification wishlist-notification--${type}`;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#28a745' : '#17a2b8'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 0.5rem;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      z-index: 10000;
      font-size: 14px;
      max-width: 300px;
      animation: slideInRight 0.3s ease;
    `;
    notification.textContent = message;

    // Add animation styles
    if (!document.querySelector('#wishlist-notification-styles')) {
      const styles = document.createElement('style');
      styles.id = 'wishlist-notification-styles';
      styles.textContent = `
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOutRight {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
      `;
      document.head.appendChild(styles);
    }

    document.body.appendChild(notification);

    // Remove notification after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Cookie helper methods
  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Get wishlist items for external use
  getWishlistItems() {
    const wishlistStr = this.getCookie(this.cookieName) || '';
    return wishlistStr ? wishlistStr.split('__') : [];
  }

  // Clear entire wishlist
  clearWishlist() {
    this.setCookie(this.cookieName, '', -1);
    this.updateWishlistButtons();
    this.checkEmptyWishlist();
    this.showMessage('Wishlist cleared', 'success');
  }
}

// Initialize wishlist when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  window.SchoolJunkieWishlist = new SchoolJunkieWishlist();
});

// Also initialize on theme section loads (for AJAX)
document.addEventListener('shopify:section:load', function() {
  if (window.SchoolJunkieWishlist) {
    window.SchoolJunkieWishlist.init();
  }
});